var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoComponent"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"id":"logo-img","src":require('@/assets/images/eclerck_logo.png'),"alt":"Eclerk"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }